import axios from 'axios'
import store from '../store'
import { eventBus } from '@/main'

const RequestErrors = {
  connect () {
    axios.interceptors.response.use((response) => {
      store.commit('errors/clearErrors')
      return response
    }, function (error) {
      if (error.response.status === 422) {
        store.commit('errors/setErrors', error.response.data)
      }
      if (error.response.status === 403) {
        eventBus.$root.$emit(
          'send_notify',
          'error',
          error.response.data.message
        )
      }
      return Promise.reject(error)
    })
  }
}

export default RequestErrors
